// const baseUrl = 'http://192.168.1.3:3000/api/';
// const baseUrl = "http://54.88.107.63:3000/api/";

const normalizeBaseUrl = (url) => {
  if (!url) {
    console.warn("REACT_APP_BASE_URL is not set");
    return "";
  }

  const trimmed = url.trim().replace(/\/+$/, "");
  if (trimmed.endsWith("/api")) {
    return `${trimmed}/`;
  }

  return `${trimmed}/api/`;
};

const baseUrl = normalizeBaseUrl(process.env.REACT_APP_BASE_URL);

module.exports = {
  // LOGIN AND REGISTER
  login: `${baseUrl}login`,
  register: `${baseUrl}register`,
  verifyEmailOTP: `${baseUrl}otp-verify`,
  resendOTP: `${baseUrl}resend-otp`,

  //dashboard
  getDashboardData: `${baseUrl}dashboard/count`,

  //forgot-password
  forgotpassword: `${baseUrl}forgot-password`,
  resetpassword: `${baseUrl}reset-password`,

  //job
  createJob: `${baseUrl}create-job`,
  getJob: (id) => `${baseUrl}get-job/${id}`,
  updateJob: (id) => `${baseUrl}update-job/${id}`,
  jobsList: `${baseUrl}jobs`,
  deleteJob: (id) => `${baseUrl}delete-job/${id}`,
  getCompanyJob: `${baseUrl}company-jobs`,
  getJobByName: `${baseUrl}get-job`,

  //job-summary
  createJobSummary: `${baseUrl}job-summary/create`,
  getJobSummaryByJobId: (id) => `${baseUrl}job-summary/get/${id}`,
  updateJobSummaryByJobId: (id) => `${baseUrl}job-summary/update/${id}`,
  changeJobSummaryStatus: (id) => `${baseUrl}job-summary/change-status/${id}`,
  jobSummaryList: `${baseUrl}job-summary/list`,

  //notification
  notificationList: `${baseUrl}notification/list`,
  hiringManagerNotificationList: `${baseUrl}hiring-manager-notification/list`,
  readNotificationById: (id) => `${baseUrl}notifications/read/${id}`,
  readAllNotifications: `${baseUrl}notifications/read-all`,
  readAllHiringManagerNotifications: `${baseUrl}hiring-manager-notifications/read-all`,

  //job-vacancy-text
  createJobVacancyText: `${baseUrl}job-vacancy-text/create`,
  getJobVacancyTextByJobId: (id) => `${baseUrl}job-vacancy-text/get/${id}`,
  updateJobVacancyTextByJobId: (id) =>
    `${baseUrl}job-vacancy-text/update/${id}`,
  getJobAndCompanyData: `${baseUrl}job-and-company-data`,

  //candidate
  createCandidate: `${baseUrl}create-candidate`,
  getCandidate: (id) => `${baseUrl}get-candidate/${id}`,
  updateCandidate: (id) => `${baseUrl}update-candidate/${id}`,
  candidatesList: `${baseUrl}candidates`,
  deleteCandidate: (id) => `${baseUrl}delete-candidate/${id}`,
  getCandidateByJob: `${baseUrl}get-candidate`,
  updateCandidateDescription: `${baseUrl}candidate-leads/view/update`,

  //company
  createCompany: `${baseUrl}create-company`,
  getCompany: (id) => `${baseUrl}get-company/${id}`,
  updateCompany: (id) => `${baseUrl}update-company/${id}`,

  //User
  getUserProfile: (id) => `${baseUrl}user/${id}`,
  updateUserProfile: (id) => `${baseUrl}update-user-profile/${id}`,
  updateUserPassword: (id) => `${baseUrl}update-user-password/${id}`,

  //Hirinn Manager
  getHiringManagerList: `${baseUrl}hiring-manager`,

  // Offer Letter
  genratePDFOfferLetter: `${baseUrl}offer-send-candidate`,
  sendOfferLetterEmail: `${baseUrl}send-email-candidate`,

  //Content Creations
  createContent: `${baseUrl}content/create`,
  getContentById: (id) => `${baseUrl}content/get/${id}`,
  contentList: `${baseUrl}content/list`,
  updateContent: (id) => `${baseUrl}content/update/${id}`,

  //Payment API
  initializePayment: `${baseUrl}payment/create-payment-intent`,
  confirmPayment: `${baseUrl}payment/confirm-payment`,

  // subscription list
  subscriptionList: `${baseUrl}subscription/list`,
  subscriptionGet: `${baseUrl}subscription/get`,
  activeSubscription: `${baseUrl}subscription/active`,
  deActiveSubscription: `${baseUrl}subscription/deactive`,
  
  // CandidatesLeads API
  createCandidateLeads: `${baseUrl}candidate-leads/create`,
  getCandidateLeads: `${baseUrl}candidate-leads/view`,
  candidatesLeadsList: `${baseUrl}candidate-leads/list`,
  updateCandidateStatus: `${baseUrl}candidate-leads/updates/status`,
  giveCandidateFeedback: `${baseUrl}candidate-leads/feedback`,
  getCandidateFeedback: `${baseUrl}candidate-leads/feedback/view`,
  sendInterViewTipsToCandidate: `${baseUrl}candidate-leads/send-interview-tips`,

  // Campaign prefill (job spec → wizard)
  getCampaignPrefill: (jobSpecId) => `${baseUrl}campaign/prefill/${jobSpecId}`,

  // Compaign Form
  createCompaignForm: `${baseUrl}campaign/create`,
  getCompaignForm: (id) => `${baseUrl}campaign/get/${id}`,
  compaignFormList: `${baseUrl}gateway/list-vonq-campaigns`,
  getVonqCampaignDetails: (campaignId) => `${baseUrl}getway/campaign-details/${campaignId}`,
  getVonqCampaignRecord: (id) => `${baseUrl}gateway/campaign-record/${id}`,
  markVonqCampaignOffline: (campaignId) => `${baseUrl}getway/campaign-offline/${campaignId}`,
  markVonqCampaignChannelOffline: `${baseUrl}getway/campaign-channel-offline`,
  candidateList : `${baseUrl}candidate-leads/list`,
  updateCompaignForm: (id) => `${baseUrl}campaign/update/${id}`,
  deleteCompaignForm: (id) => `${baseUrl}delete-campaign/${id}`,
  candidatesNeedMoreInfoEmail: `${baseUrl}candidate-leads/view/info-email`,

  // Analytics
  getAnalytics: `${baseUrl}adzuna-data-analysis`,
  getCharts: `${baseUrl}adzuna-chart-data`,
  getHistoricalChart: `${baseUrl}adzuna/historical-data`,
  getHistogramChart: `${baseUrl}adzuna/histogram-data`,
  getTopCompaniesChart: `${baseUrl}adzuna/top-companies-data`,
  getRegionalChart: `${baseUrl}adzuna/regional-data`,

  //Subscription Module
  purchaseSubscriptionStatus: `${baseUrl}my/subscription-status`,
  listOfSubscriptions: `${baseUrl}subscription/list`,
  checkOut: `${baseUrl}subscription/checkout`,
  updateSubscriptions: `${baseUrl}subscription/update`,

  // Billings
  getBillings: `${baseUrl}subscription/billing`,
  getInvoices: `${baseUrl}subscription/invoice`,
  cancelSubscriptions: `${baseUrl}subscription/cancelled`,
  restoreSubscriptions: `${baseUrl}subscription/restart`,

  //VONQ : {Form-1}
  getJobTitle: `${baseUrl}gateway/job-listing`,
  getJobFunction: `${baseUrl}gateway/job-functions`,
  getLocation: `${baseUrl}gateway/locations`,
  getIndustries: `${baseUrl}gateway/industries`,

  //VONQ : Form-2
  getFilterBy : `${baseUrl}gateway/filter-products`,

  //VONQ : Form-3
  getEducation: `${baseUrl}gateway/education-levels`,
  getSeniority: `${baseUrl}gateway/get-seniority`,

  //VONQ : form-7
  createCampaign: `${baseUrl}gateway/validate-payload`,

  //VONQ : Form8
  orderCampaign: `${baseUrl}gateway/order-campaign`,

  //VONQ : Add Candidate
  addCandidate : `${baseUrl}gateway/add-candidate`,

  //VONQ : Job-data
  jobData : `${baseUrl}gateway/extract-job-token`,

  //AI GENERATIONS
  generateImage: `${baseUrl}assistant/generate-image`,
  generateText: `${baseUrl}assistant/generate-text-assistant-thread`,
  generateTextObject: `${baseUrl}assistant/generate-text-object`,
  generateTexts: `${baseUrl}assistant/generate-text`,
};
